export default {
    getAllInstallers: () => {
        return {
            url: '/fhe/installers',
            method: 'GET'
        };
    },
    getInstallerDetails: installerId => {
        return {
            url: '/fhe/installers/:installerId',
            method: 'GET',
            route_params: {
                installerId
            }
        };
    },
    updateInstallerDetails: (installerId, installerForm) => {
        return {
            url: '/fhe/installers/:installerId',
            method: 'PATCH',
            route_params: {
                installerId
            },
            patch_params: installerForm
        };
    },
    addInstaller: installerForm => {
        return {
            url: '/fhe/installers/add',
            method: 'POST',
            patch_params: { ...installerForm, isActive: true }
        };
    },
    resetPassword: (installerId, installerForm) => {
        return {
            url: '/fhe/installers/:installerId/resetPassword',
            method: 'PATCH',
            patch_params: {
                email: installerForm.email,
                lastname: installerForm.lastname,
                firstname: installerForm.firstname
            },
            route_params: {
                installerId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Installers/api.js